import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    listWithTransportsFleet: (state) => state.list,
  },
  actions: {
    createOperator({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Shipping/api/Operators", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createTransportTool_Truck({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Shipping/api/Trucks", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createTransportTool_PickUp({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Shipping/api/PickUps", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createTransportTool_Bike({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Shipping/api/Bikes", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    addPackage({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Shipping/api/Packages", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    addTransportsFleet({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Shipping/api/TransportsFleet", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    assignOperatorToPackage({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Shipping/api/Packages/assign-operator", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    editCountOfCarton({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Shipping/api/Packages/cartons-count", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    PackageDelivered({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Shipping/api/Packages/go-to-delivered", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    assignTransportsFleet_Cost({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Shipping/api/Packages/assign-transport_fleet", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    fetchList({ commit, dispatch }) {
      return ajax.get("Shipping/api/TransportsFleetQuery").then((r) => {
        commit("setList", r.data.data);
      });
    },
    fetchListWithNOTakeSkip({ commit, dispatch }) {
      return ajax
        .get("Shipping/api/TransportsFleetQuery?Take=100&Skip=0")
        .then((r) => {
          commit("setList", r);
        });
    },
    showReceiptImage({ commit }, checkoutId) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Shipping/api/PackagesQuery/receipt-image?checkoutId=" + checkoutId
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
  },
};
